module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07512_banner_800x600.675b1e84.png";